<template>
    <div
        role="group"
        class="p-3"
    >
        <label
            :for="id"
            class="required"
        >
            {{ label ?? __('customers.customers.search.search_customer') }}
        </label>
        <div
            class="form-group"
            style="display: flex; align-items: center; width: 100%;"
        >
            <DAdvancedMultiSelect
                id="search_customer"
                add-label-classes="required"
                style="width: 25rem;"
                :options="searchResults"
                :multiple="false"
                :search="true"
                :selected="selectedCustomer"
                :selection="true"
                :options-empty-placeholder="__('customers.customers.search.no_customers_found')"
                :search-placeholder="__('customers.customers.search.search')"
                selection-type="text"
                :placeholder="__('customers.customers.search.search_customer')"
                :min-filter-length="0"
                @update="selectCustomer"
                @searchInputChanged="updateCustomerOptions"
            />
        </div>
    </div>
</template>

<script>

export default {
    name: 'SearchCustomerForm',
    props: {
        label: {
            type: String,
            default: null
        }
    },
    emits: ['selectCustomer'],
    data () {
        return {
            searchResults: [],
            selectedCustomer: [],
            customers: []
        }
    },
    computed: {
        id () {
            return 'search-customer-input'
        }
    },
    methods: {
        selectCustomer (value) {
            this.selectedCustomer = [value]

            if (value.length > 0) {
                this.$emit('selectCustomer', this.customers.filter(item => item.id === value[0])[0])
            }
        },
        updateCustomerOptions (searchTerm) {
            window.axios.post(this.$route('customers.customers.search'), {
                term: searchTerm,
                market_region_id: this.$page.props.customer.market_region.id
            })
                .then((results) => {
                    this.searchResults = []
                    this.customers = results.data.customers

                    for (const customer of results.data.customers) {
                        this.searchResults.push({
                            text: `${customer.id} - ${customer.name}`,
                            value: customer.id
                        })
                    }
                })
        }
    }
}
</script>
